import client from "./client";

export const emptyFact = () => ({ label: "", value: "" });
export const emptyStat = () => ({ value: "", label: "", accent: false });

export const emptyCustomerCase = {
  slug: "",
  client: "",
  title: "",
  summary: "",
  industrySlug: "",
  industryLabel: "",
  service: "",
  year: new Date().getFullYear(),
  logo: "",
  heroImage: "",
  facts: [emptyFact(), emptyFact(), emptyFact(), emptyFact()],
  numbers: [emptyStat(), emptyStat(), emptyStat(), emptyStat()],
  brief: "",
  solution: "",
  techUsed: "",
  stack: "",
  quoteText: "",
  quoteAuthor: "",
  quoteRole: "",
};

export function prepareCustomerCase(form = {}) {
  return {
    slug: form.slug || "",
    client: form.client || "",
    title: form.title || "",
    summary: form.summary || "",
    industrySlug: form.industrySlug || "",
    industryLabel: form.industryLabel || "",
    service: form.service || "",
    year: Number(form.year) || new Date().getFullYear(),
    logo: form.logo || "",
    heroImage: form.heroImage || "",
    facts: (form.facts || []).map((item) => ({
      label: item.label || "",
      value: item.value || "",
    })),
    numbers: (form.numbers || []).map((item) => ({
      value: item.value || "",
      label: item.label || "",
      accent: !!item.accent,
    })),
    brief: form.brief || "",
    solution: form.solution || "",
    techUsed: form.techUsed || "",
    stack: form.stack || "",
    quoteText: form.quoteText || "",
    quoteAuthor: form.quoteAuthor || "",
    quoteRole: form.quoteRole || "",
  };
}

function preferHero(item) {
  if (!item) return item;
  return { ...item, heroImage: item.heroImage || item.cover || "" };
}

export const listCustomerCases = (page = 1, limit = 100) =>
  client.post("/customercase/list", { page, limit }).then((res) => {
    const items = res.data?.data?.items;
    if (Array.isArray(items)) res.data.data.items = items.map(preferHero);
    return res;
  });
export const getCustomerCase = (id) =>
  client.post("/customercase/get", { id }).then((res) => {
    if (res.data?.data) res.data.data = preferHero(res.data.data);
    return res;
  });
export const addCustomerCase = (payload) => client.post("/customercase/add", payload);
export const updateCustomerCase = (payload) =>
  client.post("/customercase/update", payload);
export const deleteCustomerCase = (id) =>
  client.post("/customercase/delete", { id });
